import {
  required,
  min_value,
  max_value,
  between,
  regex,
  length,
  email,
  numeric,
  confirmed
} from 'vee-validate/dist/rules';
import { extend } from 'vee-validate';

extend('required', {
  ...required,
  message: field => `${field} is required.`
});

extend('email', {
  ...email,
  message: field => `${field} is not a valid email.`
});

extend('min_value', {
  ...min_value,
  message: (field, values) => {
    return `${field} must be at least ${values.min}.`;
  }
});

extend('max_value', {
  ...max_value,
  message: (field, values) => `${field} must be maximum ${values.max}.`
});

extend('regex', {
  ...regex,
  message: field => `${field} must match the shown pattern.`
});

extend('length', {
  ...length,
  message: (field, values) => `${field} must be ${values.length} long.`
});

extend('numeric', {
  ...numeric,
  message: field => `${field} is not a number.`
});

extend('between', {
  ...between,
  message: (field, values) =>
    `${field} must be between ${values.min} and ${values.max}.`
});

extend('confirmed', {
  ...confirmed,
  message: field => `${field} must match.`
});
// // Add rule for URL
extend('url', {
  // validate: value => /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(value),
  validate: value => /((http(s)?):\/\/(www\.)?)[a-zA-Z0-9@:%._\-\+~#=]{2,256}\.[a-z]{2,10}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/ig.test(value),
  message: field => `${field} must be a valid URL.`
});
